"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenValue = exports.tokens = void 0;
const common_1 = require("./common");
const components_1 = require("./components");
exports.tokens = {
    ...common_1.commonTokens,
    ...components_1.componentsTokens,
};
const getTokenValue = (token) => {
    return exports.tokens[token];
};
exports.getTokenValue = getTokenValue;
